import {useFocusEffect} from '@react-navigation/native';
import {
  Button,
  ButtonBorder,
  Div,
  DropdownMultiLanguage,
  HeaderBack,
  ImageView,
  Input,
} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';
import {getListProduct, loadProduct} from 'reducer/investment';
import {useAppSelector} from 'store/hooks';
import ListInvestMent from './ListInvestMent';
import {navigate} from 'services';

function InvestmentScreen() {
  const dispatch = useDispatch();
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const [textFilter, setTextFilter] = useState<string>('');
  const inputRef = useRef<any>(null);
  const listProduct = useAppSelector(state => getListProduct(state));
  const debounceHandle = useRef<any>(null);
  const {statusScreen} = useAppSelector(state => state.authen);

  useFocusEffect(
    React.useCallback(() => {
      if (inputRef.current) {
        inputRef.current.clear();
        setTextFilter('');
      }
      return () => {};
    }, []),
  );

  useEffect(() => {
    controlDeboundHandle(textFilter);
    return () => {};
  }, [textFilter]);

  const controlDeboundHandle = (t: string) => {
    try {
      if (debounceHandle.current) {
        clearTimeout(debounceHandle.current);
      }
      debounceHandle.current = setTimeout(() => {
        dispatch(loadProduct({productCodeOrName: t}));
      }, 300);
    } catch (error) {}
  };

  const onGoToLogin = () => {
    navigate('LoginScreen');
  };
  const onGoToRegister = () => {
    navigate('RegisterScreen');
  };

  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        title={`investmentscreen.sanpham`}
        type={9}
        rightComp={() => {
          if (statusScreen == 'unAuthorized') {
            return <DropdownMultiLanguage />;
          }
          return null;
        }}>
        <Div
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          height={48}
          borderRadius={5}
          marginTop={12}
          borderWidth={0.8}
          overflow={'hidden'}
          borderColor={Ecolors.bordercolor}
          backgroundColor={Ecolors.whiteColor}
          marginHorizontal={16}>
          <Input
            flex={1}
            margin={0}
            paddingHorizontal={16}
            height={'100%'}
            width={'100%'}
            inputRef={inputRef}
            value={textFilter}
            autoCorrect={false}
            onChangeText={(t: string) => setTextFilter(t)}
            returnKeyType={'done'}
            placeholder={
              I18nState == 'vi' ? 'Tìm kiếm quỹ đầu tư' : 'Search fund'
            }
            placeholderTextColor={Ecolors.grayColor}
            keyboardType={'name-phone-pad'}
          />
          <Button
            widthHeight={48}
            alignItems={'center'}
            justifyContent={'center'}>
            <ImageView
              source={Icons.search}
              widthHeight={18}
              resizeMode={'contain'}
              tintColor={Ecolors.grayColor}
            />
          </Button>
        </Div>
      </HeaderBack>
      <ListInvestMent data={listProduct} />
      {statusScreen == 'unAuthorized' && (
        <Div
          style={{
            height: 100,
            flexDirection: 'row',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'white',
            paddingHorizontal: 20,
            paddingTop: 20,
            shadowColor: '#000',
            shadowOffset: {width: 0, height: -5},
            shadowOpacity: 0.15,
            shadowRadius: 20,
          }}>
          <ButtonBorder
            onPress={onGoToLogin}
            style={{
              flex: 1,
              marginRight: 10,
            }}
            title="loginscreen.login"
            width={'100%'}
            buttonColor={Ecolors.mainColor}
            titleColor={Ecolors.white}
          />
          <ButtonBorder
            onPress={onGoToRegister}
            style={{flex: 1}}
            width={'100%'}
            title="registerscreen.dangki"
          />
        </Div>
      )}
    </Div>
  );
}

export default React.memo(InvestmentScreen);
